export function buildAffiliateReferralUrl(baseUrl: string, affiliateId: string): string {
  const query = new URLSearchParams({
    affiliate: affiliateId,
    utm_source: "creator",
    utm_medium: "creator",
    utm_campaign: "affiliate_program",
    utm_content: affiliateId,
  });

  if (!baseUrl) return `?${query.toString()}`;

  const url = new URL(baseUrl);
  for (const [key, value] of query) {
    url.searchParams.set(key, value);
  }
  return url.toString();
}
